import { render, staticRenderFns } from "./CollapsedPayrollDetailsReport.vue?vue&type=template&id=37ce3e8e&"
import script from "./CollapsedPayrollDetailsReport.vue?vue&type=script&lang=ts&"
export * from "./CollapsedPayrollDetailsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports